import * as React from "react";

const Checkboxes = (props: any) => (
  <svg
    width={64}
    height={64}
    viewBox="0 0 64 64"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <defs>
      <path id="a" d="M0 0h16v16H0z" />
      <path id="b" d="M0 0h16v16H0z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <path fill="none" d="M0 0h64v64H0z" fillOpacity={0} />
      <path
        d="M30 22h24"
        stroke="#7B838C"
        strokeWidth={4}
        strokeLinecap="round"
      />
      <g transform="translate(8 14)">
        <use fill="#D2D5D8" xlinkHref="#a" />
        <path stroke="#7B838C" strokeWidth={4} d="M2 2v12h12V2H2z" />
      </g>
      <path
        d="M18 21l-1.853 1.853a.208.208 0 0 1-.293 0L14 21"
        stroke="#7B838C"
        strokeWidth={2}
      />
      <g>
        <path
          d="M30 42h24"
          stroke="#7B838C"
          strokeWidth={4}
          strokeLinecap="round"
        />
        <g transform="translate(8 34)">
          <use fill="#D2D5D8" xlinkHref="#b" />
          <path stroke="#7B838C" strokeWidth={4} d="M2 2v12h12V2H2z" />
        </g>
        <path
          d="M18 41l-1.853 1.853a.208.208 0 0 1-.293 0L14 41"
          stroke="#7B838C"
          strokeWidth={2}
        />
      </g>
    </g>
  </svg>
);

export default Checkboxes;

